import React from "react";
import { images, companyInfo } from "../mock";

const Hero = () => {
  return (
    <section id="home" className="relative w-full min-h-[88vh] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${images.hero})` }}
      />
      <div className="absolute inset-0 hero-overlay" />

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto animate-fadeInUp">
        <h1 className="font-display text-white text-3xl sm:text-5xl md:text-6xl font-bold tracking-wide leading-tight">
          ERM CARGO & PACKAGING L.L.C.
        </h1>
        <h2 className="font-display mt-6 text-white text-2xl sm:text-4xl md:text-5xl font-bold leading-tight">
          MOVING THE WORLD FORWARD
          <br />
          <span className="text-[color:var(--brand-teal-light)] inline-block mt-3 border-y-2 border-[color:var(--brand-teal-light)] py-1 px-2">
            ONE SHIPMENT AT A TIME
          </span>
        </h2>
        <p className="mt-8 text-white/90 text-base sm:text-lg max-w-3xl mx-auto leading-relaxed">
          {companyInfo.description}
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="btn-red font-display uppercase tracking-wider px-8 py-3 rounded text-sm shadow-lg"
          >
            Get a Free Quote
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
